import API from 'services/api.services';
import { API_CONTACT_SUPPORT, API_GET_COMPANY_CONTACTS } from 'constants/db.constants';
import { store } from 'state/store';
import {
	setLoading,
	setFormSuccess,
	setMessage,
	setExistingContacts,
} from 'state/reducers/contact.reducers';
import { Contact } from '../constants/contact.constants';
import { intialMessage } from 'constants/ui.constants';
import { setErrorMessage } from 'utils';
import { setLoadingSettings } from 'state/reducers/settings.reducers';

export function sendContactMessage(subject: string, message: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		const paramsSetting = {
			companyId: store.getState().user.details?.companyId,
			subject,
			message,
		};
		await API.getInstance()
			.post(API_CONTACT_SUPPORT, paramsSetting)
			.then((response) => {
				dispatch(setLoading(false));
				dispatch(setFormSuccess(true));
			})
			.catch((error) => {
				setTimeout(() => {
					dispatch(setLoading(false));
					dispatch(setFormSuccess(false));
					setErrorMessage(setMessage, error);
				}, 500);
			});
	};
}

export function getContactsByCompanyId() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setLoadingSettings(true));
		dispatch(setMessage(intialMessage));
		const paramsSetting = {
			companyId: store.getState().user.details?.companyId,
		};

		await API.getInstance()
			.post(API_GET_COMPANY_CONTACTS, paramsSetting)
			.then((response) => {
				const contacts: Contact[] = response.data.companyContacts;
				dispatch(setExistingContacts(contacts));
				dispatch(setLoading(false));
				dispatch(setLoadingSettings(false));
			})
			.catch((error) => {
				dispatch(setLoading(false));
				dispatch(setLoadingSettings(false));
				dispatch(setExistingContacts([]));
				setErrorMessage(setMessage, error);
			});
	};
}
